import { useContext } from 'react';
import { isAssetAdmin, isPhoneSize } from 'utils/util';
import { GlobalContext } from 'GlobalContext';
import { BasicInfo } from './Sections/BasicInfo';
import { PropertyInfoTab } from './PropertyInfoTab';
import { TransactionInfo } from './Sections/Transaction/TransactionInfo';
import { LoanInfo } from './Sections/Loan/LoanInfo';
import { ConstructionInfo } from './Sections/Construction/ConstructionInfo';
import { RentalInfo } from './Sections/Rental/RentalInfo';
import { DesignInfo } from './Sections/Design/DesignInfo';
import backArrow from '../../../assets/img/backArrow.png';
import { InvestmentInfo } from './Sections/Investment/InvestmentInfo';
import { OtherInfo } from './Sections/Other/Other';
import { AccountingInfo } from './Sections/Accounting/AccountingInfo';

export function PropertyInfo() {
    const {
        manageAssetId,
        setManageAssetId,
        managePropertyTab,
        setManagePropertyTab,
        assetManager,
    } = useContext(GlobalContext);

    const { transactionId, loanId, constructionId, rentalId } = assetManager;

    const scrollStyle = isPhoneSize()
        ? {
              height: 'calc(100vh - 310px)',
              overflowY: 'scroll',
              scrollbarWidth: 'none',
              overflowX: 'hidden',
          }
        : {
              height: 'calc(100vh - 30px)',
              overflowY: 'scroll',
              scrollbarWidth: 'none',
              overflowX: 'hidden',
          };

    const content = (
        <div
            style={
                isPhoneSize()
                    ? {
                          height: 'calc(100vh - 230px)',
                      }
                    : {
                          height: '100vh',
                      }
            }
        >
            <div
                style={{
                    display: 'flex',
                    alignItems: 'center',
                    flexDirection: 'row',
                    // overflowX: "scroll",
                    overflowY: 'scroll',
                    scrollbarWidth: 'none',
                }}
            >
                {transactionId === 0 &&
                    loanId === 0 &&
                    constructionId === 0 &&
                    rentalId === 0 && (
                        <img
                            style={{
                                width: '15px',
                                height: '20px',
                                cursor: 'pointer',
                            }}
                            src={backArrow}
                            onClick={() => {
                                setManagePropertyTab('Basic');
                                setManageAssetId(0);
                            }}
                        ></img>
                    )}
                {manageAssetId > 0 &&
                    transactionId === 0 &&
                    loanId === 0 &&
                    constructionId === 0 &&
                    rentalId === 0 && (
                        <>
                            <PropertyInfoTab text={'Basic'} />
                            <PropertyInfoTab text={'Transaction'} />
                            <PropertyInfoTab text={'Loan'} />
                            <PropertyInfoTab text={'Construction'} />
                            <PropertyInfoTab text={'Rental'} />
                            <PropertyInfoTab text={'Design'} />
                            <PropertyInfoTab text={'Investment'} />
                            <PropertyInfoTab text={'Other'} />
                            {isAssetAdmin() && (
                                <PropertyInfoTab text={'Accounting'} />
                            )}
                        </>
                    )}
            </div>

            {/* <div style={{}}> */}
            {managePropertyTab === 'Basic' && (
                <div style={scrollStyle}>
                    <BasicInfo />
                </div>
            )}
            {managePropertyTab === 'Transaction' && <TransactionInfo />}
            {managePropertyTab === 'Loan' && <LoanInfo />}
            {managePropertyTab === 'Construction' && <ConstructionInfo />}
            {managePropertyTab === 'Rental' && <RentalInfo />}
            {managePropertyTab === 'Design' && (
                <div style={scrollStyle}>
                    <DesignInfo />
                </div>
            )}

            {managePropertyTab === 'Investment' && (
                <div style={scrollStyle}>
                    <InvestmentInfo />
                </div>
            )}
            {managePropertyTab === 'Other' && (
                <div style={scrollStyle}>
                    <OtherInfo />
                </div>
            )}
            {managePropertyTab === 'Accounting' && (
                <div style={scrollStyle}>
                    <AccountingInfo />
                </div>
            )}
            {/* </div> */}
        </div>
    );

    return <>{content}</>;
}
